const DEFAULT_RETURN_TO_BASE_URL = 'https://miao-form.local'
const MAX_RETURN_TO_LENGTH = 2048

function hasControlCharacter(value: string) {
  return Array.from(value).some((character) => {
    const code = character.charCodeAt(0)
    return code <= 31 || code === 127
  })
}

export function normalizePublicFormReturnTo(
  value: string | null | undefined,
  baseUrl = DEFAULT_RETURN_TO_BASE_URL,
) {
  const raw = value?.trim()
  if (!raw || raw.length > MAX_RETURN_TO_LENGTH || hasControlCharacter(raw)) {
    return null
  }

  try {
    const base = new URL(baseUrl)
    const url = new URL(raw, base)
    if (url.origin !== base.origin) return null
    if (!url.pathname.startsWith('/to/')) return null
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}

export function createPublicFormReturnToFromLocation(
  location: Pick<Location, 'pathname' | 'search' | 'hash'>,
) {
  return normalizePublicFormReturnTo(`${location.pathname}${location.search}${location.hash}`)
}

export function readPublicFormReturnToFromSearch(
  search: string,
  baseUrl = DEFAULT_RETURN_TO_BASE_URL,
) {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`)
  return normalizePublicFormReturnTo(params.get('returnTo'), baseUrl)
}

export function createLoginPathForPublicFormReturn(returnTo: string | null | undefined) {
  const safeReturnTo = normalizePublicFormReturnTo(returnTo)
  if (!safeReturnTo) return '/login'
  return `/login?returnTo=${encodeURIComponent(safeReturnTo)}`
}

export function createGoogleLoginPathForReturnTo(returnTo: string | null | undefined) {
  const safeReturnTo = normalizePublicFormReturnTo(returnTo)
  if (!safeReturnTo) return '/api/auth/google'
  return `/api/auth/google?returnTo=${encodeURIComponent(safeReturnTo)}`
}
